import firebase from 'firebase'
import Rebase from 're-base'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'


//IMAGES
export const giftboxBlack = 'https://s3.eu-central-1.amazonaws.com/printbaimages/black_gift_box.jpg';
export const giftboxBlue = 'https://s3.eu-central-1.amazonaws.com/printbaimages/blue_gift_box.jpg';

//export const new_pixel_id = '362065137682505'; - diana account..
//export const new_pixel_id = '363928124289007'; //new new diana august 13
export const new_pixel_id = '417742812214017'; //new daniel sept 21


//export const new_pixel_id = '533355767155917';  old ivan discontinoued
export const old_pixel_id = '1407975139316066';

//STOCK PAYMENTS
export const PAYMENT_TYPE_PRINTING_CHARGE = "printingCharge";
export const PAYMENT_TYPE_STOCK = "stock";
export const PAYMENT_TYPE_NO_NEED_TO_PAY = "noNeedToPay";


export const genderOptions = [
  {
    "category": "gender",
    "label": "male",
    "value": "male",
    "key": "male"
  },
  {
    "category": "gender",
    "label": "female",
    "value": "female",
    "key": "female"
  },
]

export const orderTypeOptions = [
  {
    "category": "orderType",
    "label": "biz",
    "value": "biz",
    "key": "biz"
  },
  {
    "category": "orderType",
    "label": "birthday",
    "value": "enter_birthday",
    "key": "enter_birthday"
  },
  {
    "category": "orderType",
    "label": "couples",
    "value": "couples",
    "key": "couples"
  },
  {
    "category": "orderType",
    "label": "faceShirt",
    "value": "faceShirt",
    "key": "faceShirt"
  },
  {
    "category": "orderType",
    "label": "family",
    "value": "family",
    "key": "family"
  },
  {
    "category": "orderType",
    "label": "misc",
    "value": "misc",
    "key": "misc"
  },
  {
    "category": "orderType",
    "label": "religious",
    "value": "religious",
    "key": "religious"
  },
  {
    "category": "orderType",
    "label": "self",
    "value": "self",
    "key": "self"
  },
  {
    "category": "orderType",
    "label": "sports",
    "value": "sports",
    "key": "sports"
  },
  {
    "category": "orderType",
    "label": "straight_outta",
    "value": "straight_outta",
    "key": "straight_outta"
  },
  {
    "category": "orderType",
    "label": "success",
    "value": "success",
    "key": "success"
  },
  {
    "category": "orderType",
    "label": "tribal",
    "value": "tribal",
    "key": "tribal"
  },
]

export const robeColors = [
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Cream",
    "value": "cream",
    "key": "cream"
  },
  {
    "category": "shirtColor",
    "label": "Sky Blue",
    "value": "skyblue",
    "key": "skyblue"
  },
  {
    "category": "shirtColor",
    "label": "Orange",
    "value": "orange",
    "key": "orange"
  },
  {
    "category": "shirtColor",
    "label": "Yellow",
    "value": "yellow",
    "key": "yellow"
  }
]

export const bringJerseyOptions = [
  {
    "category": "bringJersey",
    "label": "Yes",
    "value": "yes",
    "key": "yes"
  },
  {
    "category": "bringJersey",
    "label": "No",
    "value": "no",
    "key": "no"
  }
]

export const orderSourceOptions = [
  {
    "category": "orderSource",
    "label": "Facebook",
    "value": "facebook",
    "key": "facebook"
  },
  {
    "category": "orderSource",
    "label": "Whatsapp",
    "value": "whatsapp",
    "key": "whatsapp"
  },
  {
    "category": "orderSource",
    "label": "Instagram",
    "value": "instagram",
    "key": "instagram"
  },
  {
    "category": "orderSource",
    "label": "Twitter",
    "value": "twitter",
    "key": "twitter"
  },
  {
    "category": "orderSource",
    "label": "Walk in",
    "value": "walk_in",
    "key": "walk_in"
  },
  {
    "category": "orderSource",
    "label": "Other",
    "value": "other",
    "key": "other"
  },
  {
    "category": "orderSource",
    "label": "Agent",
    "value": "agent",
    "key": "agent"
  },
  {
    "category": "orderSource",
    "label": "SalesPerson",
    "value": "salesperson",
    "key": "salesperson"
  }
]

export const replacementReasonOptions = [
  {
    "category": "replacementReason",
    "label": "Error with the design",
    "value": "design_error",
    "key": "design_error"
  },
  {
    "category": "replacementReason",
    "label": "Wanted puff / Didnt want puff",
    "value": "puff",
    "key": "puff"
  },
  {
    "category": "replacementReason",
    "label": "Wrong size / Didnt Fit",
    "value": "wrong_size",
    "key": "wrong_size"
  },
  {
    "category": "replacementReason",
    "label": "Shirt Wrong color",
    "value": "wrong_color",
    "key": "wrong_color"
  },
  {
    "category": "replacementReason",
    "label": "Printing error",
    "value": "printing_error",
    "key": "printing_error"
  },
  {
    "category": "replacementReason",
    "label": "Letters, numbers fell off",
    "value": "ltrs_came_off",
    "key": "ltrs_came_off"
  }
]

export const replacementOptions = [
  {
    "category": "replacement",
    "label": "Yes",
    "value": "yes",
    "key": "yes"
  },
  {
    "category": "replacement",
    "label": "No",
    "value": "no",
    "key": "no"
  }
]

export const sendNewOrderSmsOptions = [
  {
    "category": "sendNewOrderSms",
    "label": "Yes",
    "value": "yes",
    "key": "yes"
  },
  {
    "category": "sendNewOrderSms",
    "label": "No",
    "value": "no",
    "key": "no"
  }
]

export const babyColors = [
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  }
]

export const thongColors = [
  {
    "category": "shirtColor",
    "label": "Red",
    "value": "red",
    "key": "red"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Navy Blue",
    "value": "navyblue",
    "key": "navyblue"
  }
]

export const boxerColors = [
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Navy Blue",
    "value": "navyblue",
    "key": "navyblue"
  }
]

export const blackWhiteColors = [
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
]

export const pillowColors = [
  {
    "category": "shirtColor",
    "label": "Red",
    "value": "red",
    "key": "red"
  },
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Grey",
    "value": "grey",
    "key": "grey"
  }
]

//SHIRT SIZES
export const babySizes = [
  { "category": "shirtSize", "label": "Small", "value": "small", "key": "small" }
];


export const vestSizes = [
  { "category": "shirtSize", "label": "Small", "value": "small", "key": "small" },
  { "category": "shirtSize", "label": "Medium", "value": "medium", "key": "medium" },
  { "category": "shirtSize", "label": "Large", "value": "large", "key": "large" },
  { "category": "shirtSize", "label": "X-Large", "value": "x_large", "key": "x_large" },
];


export const underWearSizes = [
  { "category": "shirtSize", "label": "Small", "value": "small", "key": "small" },
  { "category": "shirtSize", "label": "Medium", "value": "medium", "key": "medium" },
  { "category": "shirtSize", "label": "Large", "value": "large", "key": "large" },
];

export const vestColors = [
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Grey",
    "value": "grey",
    "key": "grey"
  }
]

export const cupColors = [
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Grey",
    "value": "grey",
    "key": "grey"
  }
]

export const jumperColors = [
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Grey",
    "value": "grey",
    "key": "grey"
  },
  {
    "category": "shirtColor",
    "label": "Red",
    "value": "red",
    "key": "red"
  },
  {
    "category": "shirtColor",
    "label": "Blue",
    "value": "blue",
    "key": "blue"
  },
]

export const shirtColors = [
  {
    "category": "shirtColor",
    "jumper": true,
    "label": "Black",
    "shirtColor": true,
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "Blue",
    "shirtColor": true,
    "value": "blue",
    "key": "blue"
  },
  {
    "category": "shirtColor",
    "label": "Gray",
    "shirtColor": true,
    "value": "gray",
    "key": "gray"
  },
  {
    "category": "shirtColor",
    "label": "Green",
    "shirtColor": true,
    "value": "green",
    "key": "green"
  },
  {
    "category": "shirtColor",
    "label": "Maroon",
    "shirtColor": true,
    "value": "maroon",
    "key": "maroon"
  },
  {
    "category": "shirtColor",
    "label": "Navy Blue",
    "shirtColor": true,
    "value": "navyblue",
    "key": "navyblue"
  },
  {
    "category": "shirtColor",
    "label": "Orange",
    "value": "orange",
    "key": "orange"
  },
  {
    "category": "shirtColor",
    "label": "Purple",
    "shirtColor": true,
    "value": "purple",
    "key": "purple"
  },
  {
    "category": "shirtColor",
    "jumper": true,
    "label": "Red",
    "shirtColor": true,
    "value": "red",
    "key": "red"
  },
  {
    "category": "shirtColor",
    "label": "Sky Blue",
    "shirtColor": true,
    "value": "skyblue",
    "key": "skyblue"
  },
  {
    "category": "shirtColor",
    "jumper": true,
    "label": "White",
    "shirtColor": true,
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Yellow",
    "shirtColor": true,
    "value": "yellow",
    "key": "yellow"
  },
  {
    "category": "shirtColor",
    "label": "Pink",
    "shirtColor": true,
    "value": "pink",
    "key": "pink"
  }
]

export const cranesColors = [
  {
    "category": "shirtColor",
    "label": "Black",
    "value": "black",
    "key": "black"
  },
  {
    "category": "shirtColor",
    "label": "Red",
    "value": "red",
    "key": "red"
  },
  {
    "category": "shirtColor",
    "label": "White",
    "value": "white",
    "key": "white"
  },
  {
    "category": "shirtColor",
    "label": "Yellow",
    "value": "yellow",
    "key": "yellow"
  }
]

export const shirtCollars = [
  {
    "category": "shirtType",
    "jumper": false,
    "label": "Normal / round_neck",
    "shirt": true,
    "value": "round_neck",
    "key": "round_neck"
  },
  {
    "category": "shirtType",
    "jumper": false,
    "label": "V-Neck",
    "shirt": true,
    "value": "v_neck",
    "key": "v_neck"
  },
  {
    "category": "shirtType",
    "jumper": false,
    "label": "Collar/ Polo",
    "shirt": true,
    "value": "collar",
    "key": "collar"
  },
  {
    "category": "shirtType",
    "jumper": false,
    "label": "Female Fit / round_neck",
    "shirt": true,
    "value": "fem_round_neck",
    "key": "fem_round_neck"
  },
  {
    "category": "shirtType",
    "jumper": false,
    "label": "Vests",
    "shirt": true,
    "value": "vest",
    "key": "vest"
  },
];

//SHIRT SIZES
export const shirtTypes = [
  {
    "category": "shirtType",
    "jumper": true,
    "label": "Jumper",
    "shirt": false,
    "value": "jumper"
  }
];

//SHIRT SIZES
export const shirtSizes = [
  { "category": "shirtSize", "label": "Child", "value": "baby", "key": "baby" },
  { "category": "shirtSize", "label": "Large", "value": "large", "key": "large" },
  { "category": "shirtSize", "label": "Medium", "value": "medium", "key": "medium" },
  { "category": "shirtSize", "label": "Small", "value": "small", "key": "small" },
  { "category": "shirtSize", "label": "X-Large", "value": "x_large", "key": "x_large" },
  { "category": "shirtSize", "label": "XX Large", "value": "xx_large", "key": "xx_large" },
  { "category": "shirtSize", "label": "XXX Large", "value": "xxx_large", "key": "xxx_large" }
];

//SHIRT SIZES
export const keychainShapes = [
  { "category": "shirtSize", "label": "Round", "value": "round", "key": "round" },
  { "category": "shirtSize", "label": "Square", "value": "square", "key": "square" },
];

export const months = [
  {
    "category": "monthToPayBack",
    "label": "January",
    "value": "January",
    "key": "January"
  },
  {
    "category": "monthToPayBack",
    "label": "February",
    "value": "February",
    "key": "February"
  },{
    "category": "monthToPayBack",
    "label": "March",
    "value": "March",
    "key": "March"
  },
  {
    "category": "monthToPayBack",
    "label": "April",
    "value": "April",
    "key": "April"
  },
  {
    "category": "monthToPayBack",
    "label": "May",
    "value": "May",
    "key": "May"
  },
  {
    "category": "monthToPayBack",
    "label": "June",
    "value": "June",
    "key": "June"
  },
  {
    "category": "monthToPayBack",
    "label": "July",
    "value": "July",
    "key": "July"
  },
  {
    "category": "monthToPayBack",
    "label": "August",
    "value": "August",
    "key": "August"
  },
  {
    "category": "monthToPayBack",
    "label": "September",
    "value": "September",
    "key": "September"
  },
  {
    "category": "monthToPayBack",
    "label": "October",
    "value": "October",
    "key": "October"
  },
  {
    "category": "monthToPayBack",
    "label": "November",
    "value": "November",
    "key": "November"
  },
  {
    "category": "monthToPayBack",
    "label": "December",
    "value": "December",
    "key": "December"
  }
];

const orderStatusOptionsConst = [
  { value: 'printing', label: 'Printing' },
  { value: 'outForDelivery', label: 'Out For Delivery' },
  { value: 'delivered', label: 'Delivered' },
];

const config = {
  apiKey: "AIzaSyB1DpNCo-lC8qIOKQF6tZEX01629Q2e7wY",
  authDomain: "printb-3daaa.firebaseapp.com",
  databaseURL: "https://printb-3daaa.firebaseio.com",
  projectId: "printb-3daaa",
  storageBucket: "printb-3daaa.appspot.com",
  messagingSenderId: "876953948048"
};

firebase.initializeApp(config);

//CORRECT ONE
export const serverIp = "https://printbaws.com/PrintBReporting/webresources/";


//export const serverIp = "https://elbfirsttext-830967995.us-west-2.elb.amazonaws.com/PrintBReporting/webresources/";

//export const serverIp = "http://localhost:8080/PrintBReporting/webresources/";

// https://elbfirsttext-830967995.us-west-2.elb.amazonaws.com:8080/PrintBReporting/webresources/orders/logDashboardLog
// https://elbfirsttext-830967995.us-west-2.elb.amazonaws.com/PrintBReporting/webresources/stockPayment/getZapierNotifs

export const zippcoServerIp = "https://zippcosupply.com:8181/bidding/resources/submit/getAllBids";


//export const miscFirebaseToolsIp = "http://localhost:5000/";
export const miscFirebaseToolsIp = "https://cors-anywhere.herokuapp.com/https://miscfirebasetools.herokuapp.com/";
export const miscFirebaseToolsIpReal = "https://miscfirebasetools.herokuapp.com/";
//export const miscFirebaseToolsIpReal = "http://localhost:5000/";

//export const pythonApiIp = "https://cors-anywhere.herokuapp.com/http://printbpython.herokuapp.com/";

//export const pythonApiIp = "http://13.58.44.50:8000/";
//export const pythonApiIp = "https://cors-anywhere.herokuapp.com/http://13.58.44.50:8000/";

export const pythonApiIp = "https://printbpython.herokuapp.com/"
//export const pythonApiIp = "http://127.0.0.1:8000/"

export const whatsapp_api_glassfish = "https://printbaws.com/PrintBReporting/webresources/whatsappApi/";


//export const whatsapp_api_glassfish = "http://localhost:8080/PrintBReporting/webresources/whatsappApi/";



//REGISTRY
//export const registryServerIp = "http://adfonz.com/registryUg/webresources/";
//export const registryServerIp = "http://localhost:8080/PrintBReporting/webresources/";
export const registryServerIp = "https://printbaws.com/PrintBReporting/webresources/";

export const admins = [
  //"testadmin@test.com",
  "nathankinene@gmail.com",
  "ivanmworozi@gmail.com",
  "josephinenassali30@gmail.com",
  //"mrdaizee@gmai.com",
  "deliveries@printboda.com",
  //"orders@printboda.com",
  // "musiimesimon4@gmail.com",
  "alijibril2@gmail.com",
  "guest1@printboda.com",
  "guest2@printboda.com",
  "guest3@printboda.com",
  //"francis@printboda.com",
  "onek@printboda.com",
  "sharriff@printboda.com",
  "billy@printboda.com",
  "rashid@printboda.com",
  "raymond@printboda.com",
  "viola@printboda.com",
  "biz@printboda.com",
  //"ibra@printboda.com",
  "daniel@printboda.com"];

export function isAdminEmail(email) {
  console.log("fx1 sent email:" + email);
  return admins.indexOf(email.toLowerCase()) > -1;
}

export function isAdminEmailNew(email, sentAdminList) {
  console.log("adx1 sent email:" + email);
  console.log("adx12 sentAdminList" + sentAdminList);
  return sentAdminList.indexOf(email.toLowerCase()) > -1;
}

export const orderStatusOptions = orderStatusOptionsConst;
export const ref = firebase.database().ref();
export const db = firebase.database();
export const firebaseAuth = firebase.auth;
//var user = firebase.auth().currentUser;
export const currentUser = firebase.auth().currentUser;
export const firebaseStorage = firebase.storage();
export const base = Rebase.createClass(firebase.database());
export const appUrl = 'https://printb-3daaa.firebaseapp.com/';
export const amplitudue_dev_project = "8821ad924dd8e7f28f50e07dc2716a69";
export const amplitudue_prod_project = "4685bf448a105478c6805699003549c9";

//Design chat actions
export const designChatActions = {
  chatOpened: "chatOpened",
  messageSent: "messageSent",
  designRejected: "designRejected",
  designApproved: "designApproved",
}

export const algoliaKey = '837deba1029595bbad3d5d1df9dabfeb';
export const alogoliaAccount = 'FV5Z3H1RLH';

export function logComponentLoad(returnObject, componentName) {
  // console.log("lcdx1 ++++++ logComponentLoad ++++++:");
  // console.log("lcdx1 componentName:"+componentName);

  if (returnObject.algoliaUser && returnObject.algoliaUser.isAdmin) {
    console.log("lcdx13 returnObject.algoliaUser && returnObject.algoliaUser.isAdmin:");

    logDashboardAction(returnObject.algoliaUser.key + " loaded " + componentName, returnObject.algoliaUser.key, null, componentName);
  }
}

export function logDashboardLogin(adminEmail, userAgent, action, componentName) {
   console.log("ldx1 ++++++ logDashboardLogin ++++++:");
  console.log("ldx1 adminEmail:"+adminEmail);
  // console.log("ldx12 adminEmail:"+adminEmail);
  // console.log("ldx13 order_num:"+order_num);

  axios.post(serverIp + 'miscEndpoints/logDashboardLogin', {
    apiKey: "sdfasdfasdf",
    logAction: action,
    adminEmail: adminEmail,
    componentName: componentName,
    userAgent: userAgent
  })
    .then((response) => {
      // console.log("ldx14 response:"+JSON.stringify(response.data, null, 3));

    })
    .catch((error) => {
      console.log(error);
      console.log("ldx13 logDashboardAction ERROR:" + error);
    });

}

export function logDashboardAction(logAction, adminEmail, order_num, componentName) {
  // console.log("ldx1 ++++++ logDashboardAction ++++++:");
  console.log("ldx1 logAction:"+logAction);
  // console.log("ldx12 adminEmail:"+adminEmail);
  // console.log("ldx13 order_num:"+order_num);

  axios.post(serverIp + 'orders/logDashboardLog', {
    apiKey: "sdfasdfasdf",
    logAction: logAction,
    adminEmail: adminEmail,
    order_num: order_num,
    componentName: componentName
  })
    .then((response) => {
      // console.log("ldx14 response:"+JSON.stringify(response.data, null, 3));

    })
    .catch((error) => {
      console.log(error);
      console.log("ldx13 logDashboardAction ERROR:" + error);
    });

}

export function ViewOrderLinkAlgolia(props) {

  return (
    <div>
      <Link to={'/dashboard/SingleOrderViewAlgolia/' + props.order_num} target="_blank">VIEW {props.order_num}</Link>
    </div>
  )
}

export function toCurrency(number) {
  //console.log("++++++: toCurrency");
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "UGX"
  });

  return formatter.format(number);
}

export function getOrderKey(order) {

  let orderKey = order.key;

  if (order.key) {
    // console.log("upx779 its NORMAL this.props.order.key:" + order.key);
    orderKey = order.key

  } else if (order.objectID) {
    // console.log("upx7791 its ALGOLIA this.props.order.objectID exists:" + order.objectID+" orderNum:"+order.order_num);   
    orderKey = order.objectID
  }

  return orderKey;
}

export function cleanPhoneRemovePlus256(phone) {
  //console.log("cprph1 ++++++ cleanPhoneRemovePlus256:" + phone)
  let newPhone = phone.replace("+256", 0)
  //console.log("cprph12 clean phone:" + newPhone)
  return newPhone

}



// WEBPACK FOOTER //
// ./src/config/constants.js